// extracted by mini-css-extract-plugin
export default {"container":"Callout_container__RZ0nm","line2":"Callout_line2__xr5Qa","line3":"Callout_line3__axQ6X","draw":"Callout_draw__1Fax9"};